export default __webpack_public_path__ + "assembly1401b99.png";